import OptimizelyTest from './OptimizelyTest'

export default OptimizelyTest
// eslint-disable-next-line import/export
export * from './OptimizelyTest'
